export default __webpack_public_path__ + "static/media/jump.c6d10861.png";